export enum Expectation {
  Beat = 'beat',
  Miss = 'miss',
}

export enum EarningState {
  Beat = 'earning-beat',
  Miss = 'earning-miss',
  Meet = 'earning-meet',
}
